/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit-element';

/**
 * Checkbox CSS
 */
export const styles = css`
   :host {
    display: inline-block;
  }

  .checkbox {
    position: relative;
    display: inline-flex;
    align-items: top;
    font-weight: 400;
    color: var(--nile-colors-dark-900);
    vertical-align: middle;
    cursor: pointer;
  }

  .checkbox--medium {
    --toggle-size: var(--nile-type-scale-3);
    font-size: var(--nile-type-scale-3);
  }

  .checkbox__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--nile-type-scale-3);
    height: var(--nile-type-scale-3);
    border: solid 1px var(--nile-colors-neutral-700);
    background-color: var(--nile-colors-white-base);
    border-radius: 4px;
    transition: var(--nile-transition-duration-default border-color), var(--nile-transition-duration-default) background-color,
    var(--nile-transition-duration-default) color, var(--nile-transition-duration-default box-shadow);
  }

  .checkbox__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }


  /* svg {
      display:none !important;
  } */

  /* Hover */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__control:hover {
    background: var(--nile-colors-primary-100);
    border: 1px solid var(--nile-colors-primary-600);
    border-radius: 4px;
  }

  /* Focus */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: solid 3px hsl(198.6 88.7% 48.4% / 40%);
    outline-offset: 1px;
  }

  /* Checked/indeterminate */
  .checkbox--checked .checkbox__control,
  .checkbox--indeterminate .checkbox__control {
    border-color: var(--nile-colors-primary-600);
    background-color: var(--nile-colors-primary-600);
  }

  /* Checked/indeterminate + hover */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__control:hover,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__control:hover {
    background: var(--nile-colors-primary-900);
    border: 1px solid var(--nile-colors-primary-900);
  }

  /* Checked/indeterminate + focus */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: solid 3px hsl(198.6 88.7% 48.4% / 40%);
    outline-offset: 1px;
  }

  /* Disabled */
  .checkbox--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .checkbox__label {
    display: inline-block;
    color: var(--nile-type-scale-3);
    line-height: 14px;
    font-size: 14px;
    margin-inline-start: 0.5em;
    user-select: none;
    margin-top: 2px;
  }

  :host([required]) .checkbox__label::after {
    content: '*';
    margin-inline-start: -2px
  }

  :host {
    --nile-svg-stroke: white;
    --nile-svg-stroke-width: 2px;
  }
`;

export default [styles];
